iScreenWizard.controller('LosseTestsSelectorController', function ($scope, $state, $mdDialog, Ajax, Dictionary, userService, Testotheek, nieuweTestafnameService) {

    $scope.userService = userService;
    $scope.testafname = nieuweTestafnameService.model;
    $scope.tests = [];

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        params = {
            testafname_opleidingsniveau_id: $scope.testafname.kandidaat.opleidingsniveau.id
        };
        Testotheek.all(params).then(function(tests) {
            $scope.tests = tests;
        });
    };

    $scope.saveTestafname = function() {
        nieuweTestafnameService.SaveState();
    };

    $scope.continue = function() {
        $state.go('nieuwe-testafname/uitnodiging');
    }

});